(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(564);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const AdSenseBanner = (param)=>{
    let { adUnitId , adSlotId  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "p-1",
        align: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle",
            style: {
                display: "block"
            },
            "data-ad-client": "".concat(adUnitId),
            "data-ad-slot": "".concat(adSlotId),
            "data-ad-format": "auto",
            "data-full-width-responsive": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdSenseBanner);


/***/ }),

/***/ 564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ IndexPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(8352);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(1911);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./lib/imageLoader.js
var imageLoader = __webpack_require__(1820);
;// CONCATENATED MODULE: ./components/AffiliateBanner.js



const AffiliateBanner = (param)=>{
    let { affiliate , onClick  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "p-0 w-100 d-flex justify-content-center",
        style: {
            background: affiliate.background
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: affiliate.affiliateUrl,
            target: "_blank",
            rel: "noreferrer",
            className: "p-0 position-relative d-flex justify-content-center",
            children: [
                affiliate.customBannerImageUrl != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: affiliate.customBannerImageUrl,
                        loader: imageLoader/* ExternalImageLoader */.N,
                        alt: "advertising-impression",
                        width: 1,
                        height: 1,
                        objectFit: "none",
                        unoptimized: true,
                        "data-key": affiliate.key
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: affiliate.bannerImageUrl,
                    loader: imageLoader/* ExternalImageLoader */.N,
                    className: "img-fluid",
                    alt: "advertising",
                    width: affiliate.bannerImageWidth,
                    height: affiliate.bannerImageHeight,
                    layout: "intrinsic",
                    unoptimized: true,
                    onClick: onClick,
                    "data-key": affiliate.key
                })
            ]
        })
    }, affiliate.key);
};
/* harmony default export */ var components_AffiliateBanner = (AffiliateBanner);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(1669);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(6797);
// EXTERNAL MODULE: ./styles/components/AffiliateCarousel.module.css
var AffiliateCarousel_module = __webpack_require__(6948);
var AffiliateCarousel_module_default = /*#__PURE__*/__webpack_require__.n(AffiliateCarousel_module);
;// CONCATENATED MODULE: ./components/AffiliateCarousel.js









const AffiliateCarousel = (param)=>{
    let { affiliates , onClick  } = param;
    swiper_esm/* default.use */.ZP.use(affiliates.length > 1 ? [
        swiper_esm/* Autoplay */.pt,
        swiper_esm/* Navigation */.W_,
        swiper_esm/* Pagination */.tl
    ] : []);
    let navigationStyle = affiliates.length > 1 ? {
        color: "white"
    } : {
        color: "white",
        display: "none"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mx-1 my-1 font-italic",
                children: "Advertisements"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                id: "swiper",
                loop: true,
                autoplay: {
                    delay: "5000",
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                navigation: {
                    prevEl: ".swiper-button-prev",
                    nextEl: ".swiper-button-next"
                },
                pagination: {
                    clickable: true,
                    bulletClass: "swiper-pagination-bullet ".concat((AffiliateCarousel_module_default())["bullet-class"]),
                    bulletActiveClass: "swiper-pagination-bullet-active ".concat((AffiliateCarousel_module_default())["bullet-class-active"])
                },
                children: [
                    affiliates.map((affiliate)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AffiliateBanner, {
                                affiliate: affiliate,
                                onClick: onClick
                            })
                        }, affiliate.key);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "swiper-button-next",
                        style: navigationStyle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "swiper-button-prev",
                        style: navigationStyle
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_AffiliateCarousel = (AffiliateCarousel);

;// CONCATENATED MODULE: ./components/WordCountInfoPanel.js

const WordCountInfoPanel = (param)=>{
    let { id , title , value , unit , tooltip  } = param;
    let tooltipProps = {};
    if (tooltip != null) {
        tooltipProps["data-bs-toggle"] = "tooltip";
        tooltipProps["data-bs-placement"] = "bottom";
        tooltipProps["title"] = tooltip;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-sm-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "card h-100 text-center",
            ...tooltipProps,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "".concat(id, "-card"),
                className: "card-body",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "card-text mb-1",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "h5 card-title mb-1",
                        children: value
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "card-text mb-0",
                        children: unit
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_WordCountInfoPanel = (WordCountInfoPanel);

;// CONCATENATED MODULE: ./components/WordDensityRow.js

const WordDensityRow = (param)=>/*#__PURE__*/ {
    let { item  } = param;
    return (0,jsx_runtime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                id: "index",
                scope: "row",
                children: item.index
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                id: "word",
                children: item.word
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                id: "count",
                children: item.count
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                id: "density",
                children: item.density
            })
        ]
    }, item);
};
/* harmony default export */ var components_WordDensityRow = (WordDensityRow);

;// CONCATENATED MODULE: ./components/WordDensityTable.js


const WordDensityTable = (param)=>/*#__PURE__*/ {
    let { wordDensityList  } = param;
    return (0,jsx_runtime.jsx)("div", {
        id: "word-density-container",
        className: "p-2 mx-2 my-1 table-responsive",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
            id: "word-density-table-head",
            className: "table table-striped table-hover",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                className: "col-md-1",
                                scope: "col",
                                children: "#"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                className: "col-md-5",
                                scope: "col",
                                children: "คำ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                className: "col-md-3",
                                scope: "col",
                                children: "จำนวน(คำ)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                className: "col-md-3",
                                scope: "col",
                                children: "ความหนาแน่น(%)"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    id: "word-density-table-body",
                    className: "notranslate",
                    children: wordDensityList.map((wordDensity)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordDensityRow, {
                                item: wordDensity
                            })
                        });
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_WordDensityTable = (WordDensityTable);

;// CONCATENATED MODULE: ./components/WordBadge.js

const WordBadge = (param)=>/*#__PURE__*/ {
    let { word  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: "ms-1 mt-1 p-2 badge rounded-pill bg-dark",
        children: word
    }, word);
};
/* harmony default export */ var components_WordBadge = (WordBadge);

// EXTERNAL MODULE: ./node_modules/docxtemplater/js/docxtemplater.js
var docxtemplater = __webpack_require__(4522);
var docxtemplater_default = /*#__PURE__*/__webpack_require__.n(docxtemplater);
// EXTERNAL MODULE: ./node_modules/pizzip/js/index.js
var js = __webpack_require__(1344);
var js_default = /*#__PURE__*/__webpack_require__.n(js);
// EXTERNAL MODULE: ./node_modules/pdfjs-dist/build/pdf.js
var pdf = __webpack_require__(9299);
;// CONCATENATED MODULE: ./components/DocumentFileSelector.js





pdf.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdf.version, "/pdf.worker.min.js");
const DocumentFileSelector = (param)=>{
    let { onContentReady  } = param;
    const pdfFileSelecterRef = (0,react.useRef)();
    const docxFileSelecterRef = (0,react.useRef)();
    const textFileSelecterRef = (0,react.useRef)();
    const onFileTypeSelect = (e)=>{
        e.preventDefault();
        ;
        e.target.id;
        if (e.target.id == "pdf-file-selector") {
            pdfFileSelecterRef.current.value = "";
            pdfFileSelecterRef.current.click();
        } else if (e.target.id == "docx-file-selector") {
            docxFileSelecterRef.current.value = "";
            docxFileSelecterRef.current.click();
        } else if (e.target.id == "text-file-selector") {
            textFileSelecterRef.current.value = "";
            textFileSelecterRef.current.click();
        }
    };
    const publishContentReady = (event, content)=>{
        if (content.length > 50000) {
            content = content.substring(0, 50000);
        }
        onContentReady(event, content);
    };
    const onPdfFileChanged = (event)=>{
        ;
        const fileReader = new FileReader();
        const { files  } = event.target;
        if (files.length > 0) {
            fileReader.readAsArrayBuffer(files[0]);
            fileReader.onload = (e)=>{
                ;
                var typedarray = new Uint8Array(e.target.result);
                const loadingTask = pdf.getDocument(typedarray);
                loadingTask.promise.then((pdf)=>{
                    var maxPages = pdf.numPages;
                    var countPromises = [];
                    for(var j = 1; j <= maxPages; j++){
                        var page = pdf.getPage(j);
                        countPromises.push(page.then(function(page) {
                            var textContent = page.getTextContent();
                            return textContent.then(function(text) {
                                return text.items.map(function(s) {
                                    return s.str;
                                }).join("");
                            });
                        }));
                    }
                    Promise.all(countPromises).then(function(texts) {
                        return texts.join("\n");
                    }).then(function(content) {
                        publishContentReady(event, content);
                    });
                });
            };
        }
    };
    const onDocxFileChanged = (event)=>{
        ;
        const fileReader = new FileReader();
        const { files  } = event.target;
        if (files.length > 0) {
            fileReader.readAsBinaryString(files[0], "UTF-8");
            fileReader.onload = (e)=>{
                ;
                let content = e.target.result;
                let zip = new (js_default())(content);
                let doc = new (docxtemplater_default())().loadZip(zip);
                content = doc.getFullText();
                publishContentReady(event, content);
            };
        }
    };
    const onTextFileChanged = (event)=>{
        ;
        const fileReader = new FileReader();
        const { files  } = event.target;
        if (files.length > 0) {
            fileReader.readAsText(files[0], "UTF-8");
            fileReader.onload = (e)=>{
                ;
                const content = e.target.result;
                publishContentReady(event, content);
            };
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "btn-group",
        role: "group",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                id: "btn-file-type-group",
                type: "button",
                className: "btn btn-primary dropdown-toggle",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false",
                children: "ดึงข้อมูลจากไฟล์"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "dropdown-menu",
                "aria-labelledby": "btnGroupDrop1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            id: "pdf-file-selector",
                            className: "dropdown-item",
                            onClick: onFileTypeSelect,
                            children: ".pdf"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            id: "docx-file-selector",
                            className: "dropdown-item",
                            onClick: onFileTypeSelect,
                            children: ".docx"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            id: "text-file-selector",
                            className: "dropdown-item",
                            onClick: onFileTypeSelect,
                            children: ".txt"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "pdf-file-selector-input",
                ref: pdfFileSelecterRef,
                type: "file",
                style: {
                    display: "none"
                },
                accept: ".pdf",
                onChange: onPdfFileChanged
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "docx-file-selector-input",
                ref: docxFileSelecterRef,
                type: "file",
                style: {
                    display: "none"
                },
                accept: ".docx",
                onChange: onDocxFileChanged
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "text-file-selector-input",
                ref: textFileSelecterRef,
                type: "file",
                style: {
                    display: "none"
                },
                accept: ".txt",
                onChange: onTextFileChanged
            })
        ]
    });
};
/* harmony default export */ var components_DocumentFileSelector = (DocumentFileSelector);

// EXTERNAL MODULE: ./components/AdSenseBanner.js
var AdSenseBanner = __webpack_require__(3605);
// EXTERNAL MODULE: ./node_modules/firebase/remote-config/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(6526);
// EXTERNAL MODULE: ./lib/firebase.js + 1 modules
var firebase = __webpack_require__(4606);
;// CONCATENATED MODULE: ./lib/firebaseRemoteConfig.js


const AFFILIATE_CONFIG_KEY = "affiliate_config";
const AFFILIATE_DISPLAY_CONFIG_KEY = "affiliate_display_config";
let frConfig;
const AFFILIATE_DISPLAY_CONFIG = {
    force_display: false,
    display_rate: 0.2
};
function remoteConfig(next) {
    let sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (frConfig === undefined) {
        frConfig = (0,index_esm/* getRemoteConfig */.sN)(firebase/* firebase */.w);
        frConfig.settings.minimumFetchIntervalMillis = "12" * 3600000;
        frConfig.defaultConfig = {
            affiliate_config: null,
            affiliate_display_config: JSON.stringify(AFFILIATE_DISPLAY_CONFIG)
        };
        if (sync) {
            ;
            (0,index_esm/* fetchAndActivate */.xS)(frConfig).then(()=>{
                ;
                if (next != undefined && next != null) {
                    next();
                }
            }).catch((err)=>{
                ;
            });
        } else {
            next();
        }
    } else {
        if (next != undefined && next != null) {
            next();
        }
    }
}
function getAffiliateConfig() {
    let frValue = null;
    try {
        const value = (0,index_esm/* getValue */.NA)(frConfig, AFFILIATE_CONFIG_KEY)._value;
        if (value == "null") {
            frValue = null;
        } else {
            frValue = JSON.parse(value);
        }
    } catch (e) {
        ;
        frValue = null;
    }
    if (frValue !== null) {
        if (frValue.constructor !== Object) {
            ;
            frValue = null;
        } else {
            let keys = Object.keys(frValue);
            let rn = Math.floor(Math.random() * keys.length);
            frValue = frValue[keys[rn]];
            frValue = frValue.sort(()=>Math.random() - 0.5);
        }
    }
    return frValue;
}
function getAffiliateDisplayConfig() {
    let frValue = null;
    try {
        const value = getValue(frConfig, AFFILIATE_DISPLAY_CONFIG_KEY)._value;
        ;
        if (value == "null") {
            frValue = null;
        } else {
            frValue = JSON.parse(value);
        }
    } catch (e) {
        ;
        frValue = null;
    }
    return frValue;
}


// EXTERNAL MODULE: ./contexts/AdControllerContext.js
var AdControllerContext = __webpack_require__(4142);
;// CONCATENATED MODULE: ./lib/localConfig.js
const WORD_DENSITY_EXCLUDE_STOP_WORDS = "word_density_exclude_stop_words";
function getLocalConfig(configKey) {
    if (window !== undefined && window !== null) {
        return localStorage.getItem(configKey);
    } else {
        return null;
    }
}
function setLocalConfig(configKey, value) {
    if (window !== undefined && window !== null) {
        localStorage.setItem(configKey, value);
    }
}
function getBooleanLocalConfig(configKey, defaultValue) {
    let value = getLocalConfig(configKey);
    ;
    if (value != null) {
        return value === "true";
    } else {
        return defaultValue;
    }
}
function setBooleanLocalConfig(configKey, value) {
    setLocalConfig(configKey, value.toString());
}


// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
;// CONCATENATED MODULE: ./pages/api/dictionary.js


const thDictionaryFetcher = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return fetch(...args).then((res)=>res.text()).then((text)=>{
        try {
            const dicts = text.split("\n");
            let words = dicts.flat();
            words = [
                ...new Set(words)
            ];
            ;
            return words;
        } catch (e) {
            return new Promise.error(e);
        }
    }).catch((e)=>{
        (0,esm_exports/* captureException */.Tb)(e);
        return e;
    });
};
function useThDictionary() {
    const { data , error  } = (0,dist/* default */.ZP)("/dictionary/th/dictionary.txt", thDictionaryFetcher, {
        revalidateOnFocus: false,
        errorRetryInterval: 1000,
        shouldRetryOnError: true,
        errorRetryCount: 3,
        loadingTimeout: 10000
    });
    return {
        words: data,
        isLoading: !error && !data,
        isError: error
    };
}
function useThStopWords() {
    const { data , error  } = (0,dist/* default */.ZP)("/dictionary/th/stopwords.txt", thDictionaryFetcher, {
        revalidateOnFocus: false,
        errorRetryInterval: 1000,
        shouldRetryOnError: true,
        errorRetryCount: 3,
        loadingTimeout: 10000
    });
    return {
        words: data,
        isLoading: !error && !data,
        isError: error
    };
}

;// CONCATENATED MODULE: ./nlp/common/Trie.js
class Trie {
    add(word) {
        word = word.trim();
        this.words.add(word);
        var cur = this.root;
        for(var i = 0; i < word.length; i++){
            var child1 = cur.children[word[i]];
            if (child1 === undefined) {
                child1 = new Trie.Node();
                cur.children[word[i]] = child1;
            }
            cur = child1;
        }
        cur.end = true;
    }
    remove(word) {
        if (!this.words.has(word)) {
            return;
        }
        this.words.delete(word);
        var parent = this.root;
        data = [];
        for(var i = 0; i < word.length; i++){
            child = parent.children[word[i]];
            data.push({
                parent: parent,
                child: child,
                ch: word[i]
            });
            parent = child;
        }
        child.end = false;
        for (const node of data){
            if (node.child.end || node.child.children != undefined) {
                break;
            }
            delete node.parent.children[node.ch];
        }
    }
    prefixes(text) {
        var res = [];
        var cur = this.root;
        for(var i = 0; i < text.length; i++){
            var node = cur.children[text[i]];
            if (node === undefined) {
                break;
            }
            if (node.end) {
                res.push(text.slice(0, i + 1));
            }
            cur = node;
        }
        return res;
    }
    contain(key) {
        return key in this.words;
    }
    len() {
        return this.words.size;
    }
    constructor(words){
        this.words = new Set(words || []);
        this.root = new Trie.Node();
        for(var i = 0; i < words.length; i++){
            this.add(words[i]);
        }
    }
}
Trie.Node = class {
    constructor(){
        this.end = false;
        this.children = {};
    }
};
/* harmony default export */ var common_Trie = (Trie);

;// CONCATENATED MODULE: ./nlp/tokenize/tcc.js
const _RE_TCC = "เc็c\nเcctาะ\nเccีtยะ\nเccีtย(?=[เ-ไก-ฮ]|$)\nเcc็c\nเcิc์c\nเcิtc\nเcีtยะ?\nเcืtอะ?\nเc[ิีุู]tย(?=[เ-ไก-ฮ]|$)\nเctา?ะ?\ncัtวะ\nc[ัื]tc[ุิะ]?\nc[ิุู]์\nc[ะ-ู]t\nc็\nct[ะาำ]?\nแc็c\nแcc์\nแctะ\nแcc็c\nแccc์\nโctะ\n[เ-ไ]ct".replaceAll("c", "[ก-ฮ]").replaceAll("t", "[่-๋]?").split("\n");
const _PAT_TCC = new RegExp(_RE_TCC.join("|"));
function* tcc(text) {
    if (typeof text !== "string") {
        return "";
    }
    let lenText = text.length;
    let p = 0;
    while(p < lenText){
        let m = _PAT_TCC.exec(text.slice(p, lenText));
        let n;
        if (m !== null && m.index == 0) {
            n = m.index + m[0].length;
        } else {
            n = 1;
        }
        yield text.slice(p, p + n);
        p = p + n;
    }
}
function tccPos(text) {
    let pSet = new Set();
    if (typeof text !== "string") {
        return pSet;
    }
    let p = 0;
    const tccGen = tcc(text);
    let w = tccGen.next();
    while(!w.done){
        p = p + w.value.length;
        pSet.add(p);
        w = tccGen.next();
    }
    return pSet;
}

;// CONCATENATED MODULE: ./nlp/common/heapq.js
function heappush(heap, newKey) {
    // push the new key 
    heap.push(newKey);
    // get the current index of pushed key
    let curr = heap.length - 1;
    // keep comparing till root is reached or we terminate in middle
    while(curr > 0){
        let parent = Math.floor((curr - 1) / 2);
        if (heap[curr] < heap[parent]) {
            // quick swap
            [heap[curr], heap[parent]] = [
                heap[parent],
                heap[curr]
            ];
            // update the index of newKey
            curr = parent;
        } else {
            break;
        }
    }
}
function heappop(heap) {
    // swap root with last node
    const n = heap.length;
    [heap[0], heap[n - 1]] = [
        heap[n - 1],
        heap[0]
    ];
    // remove the root i.e. the last item (because of swap)
    const removedKey = heap.pop();
    let curr = 0;
    // keep going till atleast left child is possible for current node
    while(2 * curr + 1 < heap.length){
        const leftIndex = 2 * curr + 1;
        const rightIndex = 2 * curr + 2;
        const minChildIndex = rightIndex < heap.length && heap[rightIndex] < heap[leftIndex] ? rightIndex : leftIndex;
        if (heap[minChildIndex] < heap[curr]) {
            // quick swap, if smaller of two children is smaller than the parent (min-heap)
            [heap[minChildIndex], heap[curr]] = [
                heap[curr],
                heap[minChildIndex]
            ];
            curr = minChildIndex;
        } else {
            break;
        }
    }
    // finally return the removed key
    return removedKey;
}
function heapify(arr) {
    const heap = [];
    for (let item of arr){
        heappush(heap, item);
    }
    return heap;
}

;// CONCATENATED MODULE: ./nlp/tokenize/newmm.js



const _PAT_NONTHAI = RegExp("(?<x>)[-a-zA-Z]+|\\d+([,\\.]\\d+)*|[ \\t]+|\\r?\\n");
const _PAT_THAI_TWOCHARS = new RegExp("[ก-ฮ]{,2}$");
const _MAX_GRAPH_SIZE = 50;
function* bfsPathGraph(graph, start, goal) {
    let queue = [
        {
            vertex: start,
            path: [
                start
            ]
        }
    ];
    while(queue === undefined || queue.length > 0){
        let node = queue.shift();
        if (graph[node.vertex] !== undefined) {
            for (let pos of graph[node.vertex]){
                if (pos === goal) {
                    yield node.path.concat(pos);
                } else {
                    queue.push({
                        vertex: pos,
                        path: node.path.concat(pos)
                    });
                }
            }
        }
    }
}
function* oneCut(text, customDict) {
    const graph = {};
    let graphSize = 0;
    const validPoss = tccPos(text);
    let lenText = text.length;
    const posList = heapify([
        0
    ]);
    let endPos = 0;
    while(posList[0] < lenText){
        let beginPos = heappop(posList);
        for (let word of customDict.prefixes(text.slice(beginPos, lenText))){
            let endPosCandidate = beginPos + word.length;
            if (validPoss.has(endPosCandidate)) {
                if (!(beginPos in graph)) {
                    graph[beginPos] = [];
                }
                graph[beginPos].push(endPosCandidate);
                graphSize = graphSize + 1;
                if (!posList.includes(endPosCandidate)) {
                    heappush(posList, endPosCandidate);
                }
                if (graphSize > _MAX_GRAPH_SIZE) {
                    break;
                }
            }
        }
        let lenPosList = posList.length;
        if (lenPosList === 1) {
            const endPosCandidatesGen = bfsPathGraph(graph, endPos, posList[0]);
            graphSize = 0;
            let endPosCandidates = endPosCandidatesGen.next();
            for (let pos of endPosCandidates.value){
                yield text.slice(endPos, pos);
                endPos = pos;
            }
        } else if (lenPosList === 0) {
            let m = _PAT_NONTHAI.exec(text.slice(beginPos, lenText));
            if (m != null && m.index == 0) {
                endPos = beginPos + (m.index + m[0].length);
            } else {
                endPos = null;
                for(let pos1 = beginPos; pos1 < lenText; pos1++){
                    if (validPoss.has(pos1)) {
                        var prefix = text.slice(pos1, lenText);
                        var words = [];
                        for (let word1 of customDict.prefixes(prefix)){
                            if (validPoss.has(pos1 + word1.length) && _PAT_THAI_TWOCHARS.exec(word1) === null) {
                                words.push(word1);
                            }
                        }
                        if (words.length > 0) {
                            endPos = pos1;
                            break;
                        }
                        m = _PAT_NONTHAI.exec(prefix);
                        if (m !== null && m.index == 0) {
                            endPos = pos1;
                            break;
                        }
                    }
                }
                if (endPos == null) {
                    endPos = lenText;
                }
            }
            if (!(beginPos in graph)) {
                graph[beginPos] = [];
            }
            graph[beginPos].push(endPos);
            graphSize = graphSize + 1;
            yield text.slice(beginPos, endPos);
            heappush(posList, endPos);
        }
    }
}
class NewMmTokenizer {
    tokenize(text) {
        const dict = this.dictionary;
        if (typeof text !== "string") {
            return [];
        }
        text = text.replaceAll("\n", " ");
        const textParts = text.split(" ");
        let tokens = [];
        for (let textPart of textParts){
            tokens = tokens.concat([
                ...oneCut(textPart, dict)
            ]);
            tokens.push(" ");
        }
        tokens = tokens.filter((token)=>token.length > 0);
        return tokens;
    }
    constructor(words){
        this.dictionary = new common_Trie(words);
    }
}
/* harmony default export */ var newmm = (NewMmTokenizer);

;// CONCATENATED MODULE: ./nlp/common/textutils.js
const KEEP_CONTENT_CHAR_REGEX = /[^A-Za-z0-9ก-๙]/;
const TRIM_MULTIPLE_SPACE_REGEX = /\s+/;
function keepContentChar(message) {
    return message.replace(KEEP_CONTENT_CHAR_REGEX, "");
}
function trimMultipleSpace(message) {
    return message.replace(TRIM_MULTIPLE_SPACE_REGEX, " ");
}

;// CONCATENATED MODULE: ./nlp/countword/countword.js

const READING_SPEED_WPM = 200;
const SPEAKING_SPEED_WPM = 130;
const MAXIMUM_WORD_DENSITY_DISPLAY = 10;
function wordCount(text, tokenizer, stopWords) {
    let cleanContent = trimMultipleSpace(text);
    let tokenizedWordList = tokenizer.tokenize(cleanContent);
    tokenizedWordList = tokenizedWordList.map(function(token) {
        token = token.replaceAll(" ", "");
        token = keepContentChar(token);
        return token;
    });
    tokenizedWordList = tokenizedWordList.filter((token)=>token.length != "");
    let wordDensityObj = {};
    for (word of tokenizedWordList){
        if (!(word in wordDensityObj)) {
            wordDensityObj[word] = 0;
        }
        wordDensityObj[word] += 1;
    }
    const fullWordDensityList = [];
    for(var word in wordDensityObj){
        fullWordDensityList.push([
            word,
            wordDensityObj[word]
        ]);
    }
    fullWordDensityList.sort((a, b)=>b[1] - a[1]);
    const wordDensityList = [];
    let wordIndex = 1;
    let latestWordCount;
    for (word of fullWordDensityList){
        if (wordIndex > MAXIMUM_WORD_DENSITY_DISPLAY && latestWordCount != word[1]) {
            break;
        }
        if (stopWords !== undefined && stopWords !== null && stopWords.includes(word[0])) {
            continue;
        }
        wordDensityList.push({
            index: wordIndex,
            word: word[0],
            count: word[1],
            density: (word[1] / tokenizedWordList.length * 100).toFixed(1)
        });
        latestWordCount = word[1];
        wordIndex += 1;
    }
    return {
        wordCount: tokenizedWordList.length,
        charCount: text.length,
        readingTime: Math.ceil(tokenizedWordList.length / READING_SPEED_WPM),
        speakingTime: Math.ceil(tokenizedWordList.length / SPEAKING_SPEED_WPM),
        words: tokenizedWordList,
        wordDensity: wordDensityList
    };
}

// EXTERNAL MODULE: ./lib/firebaseAnalytic.js + 2 modules
var firebaseAnalytic = __webpack_require__(2231);
// EXTERNAL MODULE: ./styles/IndexPage.module.css
var IndexPage_module = __webpack_require__(3384);
var IndexPage_module_default = /*#__PURE__*/__webpack_require__.n(IndexPage_module);
;// CONCATENATED MODULE: ./pages/index.js

















function IndexPage() {
    const [wordDensityExcludeStopWords, setWordDensityExcludeStopWords] = (0,react.useState)(false);
    const [affiliates, setAffiliates] = (0,react.useState)(null);
    const [showAffiliate] = (0,AdControllerContext/* useAdControllerContext */.yo)();
    const [logUserTyping, setLogUserTyping] = (0,react.useState)(true);
    const [content, setContent] = (0,react.useState)("");
    const [tokenizer, setTokenizer] = (0,react.useState)(null);
    const [wordCounter, setWordCounter] = (0,react.useState)({
        wordCount: 0,
        charCount: 0,
        readingTime: 0,
        speakingTime: 0,
        words: [],
        wordDensity: []
    });
    const { words: dictionary , isLoading: isDictionaryLoading , isError: isDictionaryError  } = useThDictionary();
    const { words: stopWords , isLoading: isStopWordsLoading , isError: isStopWordsError  } = useThStopWords();
    const onClearTextInputClick = (e)=>{
        e.preventDefault();
        setContent("");
        (0,firebaseAnalytic/* logAppUsage */.NY)(e);
        setLogUserTyping(true);
    };
    const onTextInputChange = (e)=>{
        if (logUserTyping) {
            (0,firebaseAnalytic/* logAppUsage */.NY)(e);
            setLogUserTyping(false);
        }
        setContent(e.target.value);
    };
    const onExcludeStopwirdSwitchChange = (e)=>{
        (0,firebaseAnalytic/* logAppUsage */.NY)(e, "configuration_changed");
        setBooleanLocalConfig(WORD_DENSITY_EXCLUDE_STOP_WORDS, e.target.checked);
        setWordDensityExcludeStopWords(e.target.checked);
    };
    const onAffiliateClick = (e)=>{
        (0,firebaseAnalytic/* logAffiliateClickEvent */.HA)(e);
    };
    const onContentReady = (e, c)=>{
        (0,firebaseAnalytic/* logAppUsage */.NY)(e);
        setContent(c);
    };
    (0,react.useEffect)(()=>{
        setWordDensityExcludeStopWords(getBooleanLocalConfig(WORD_DENSITY_EXCLUDE_STOP_WORDS, false));
    }, []);
    (0,react.useEffect)(()=>{
        remoteConfig(()=>{
            setAffiliates(getAffiliateConfig());
        }, true);
    }, [
        showAffiliate
    ]);
    (0,react.useEffect)(()=>{
        if (dictionary !== undefined && dictionary != null) {
            if (tokenizer == null) {
                ;
                setTokenizer(new newmm(dictionary));
            }
        }
    }, [
        dictionary,
        tokenizer
    ]);
    (0,react.useEffect)(()=>{
        if (tokenizer) {
            setWordCounter(wordCount(content, tokenizer, wordDensityExcludeStopWords ? stopWords : []));
        }
    }, [
        content,
        tokenizer,
        stopWords,
        wordDensityExcludeStopWords
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "เครื่องมือนับคำออนไลน์ภาษาไทยและภาษาอังกฤษ | ",
                            "CanCount"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "เครื่องมือนับคำออนไลน์ ทำงานได้กับภาษาไทยและภาษาอังกฤษ ใช้ได้ฟรี ที่จะช่วยนับจำนวนคำและตัวอักษร ได้อย่างแม่นยำและรวดเร็ว ให้งานเขียนของคุณง่ายขึ้น"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "นับคำ, นับคำภาษาไทย, ความหนาแน่นคำ"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:title",
                        content: "เครื่องมือนับคำออนไลน์ภาษาไทยและภาษาอังกฤษ | ".concat("CanCount")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "og:description",
                        content: "เครื่องมือนับคำออนไลน์ ทำงานได้กับภาษาไทยและภาษาอังกฤษ ใช้ได้ฟรี ที่จะช่วยนับจำนวนคำและตัวอักษร ได้อย่างแม่นยำและรวดเร็ว ให้งานเขียนของคุณง่ายขึ้น"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "w-100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-2 mb-1 card",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-4 py-2 my-2 text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "h4",
                                        children: [
                                            "เครื่องมือนับคำออนไลน์ภาษาไทยและภาษาอังกฤษ | ",
                                            "CanCount"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "ยินดีต้อนรับเข้าสู่ CanCount",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "หากคุณต้องการเริ่มใช้งาน คุณสามารถคัดลอกบทความและวางข้อความลงในช่องนับคำที่ปรากฎด้านล่างนี้",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "หรือเลือกไฟล์ (.pdf, .docx, .txt) จากอุปกรณ์ของท่าน เพียงเท่านี้ก็พร้อมทราบจำนวนคำและความหนาแน่นของคำหลักแบบแม่นยำได้ทันที!!"
                                        ]
                                    })
                                ]
                            }),
                            showAffiliate && affiliates !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AffiliateCarousel, {
                                affiliates: affiliates,
                                onClick: onAffiliateClick
                            }),
                            !showAffiliate && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdSenseBanner/* default */.Z, {
                                adSlotId: "".concat("6488016911"),
                                adUnitId: "".concat("ca-pub-5783368027852899")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "input-container",
                                        className: "px-2 py-1 position-relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "loader",
                                                className: "".concat((IndexPage_module_default())["loader-dimer"], " position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center ").concat(isDictionaryLoading ? "visible" : "invisible"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "spinner-grow text-info float-center ".concat((IndexPage_module_default())["loader-size"]),
                                                    role: "status",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "py-1 w-100 d-flex flex-row-reverse",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "btn-group",
                                                    role: "group",
                                                    "aria-label": "Button group with nested dropdown",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DocumentFileSelector, {
                                                            onContentReady: onContentReady
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            id: "clear-content-btn",
                                                            className: "btn btn-block btn-danger",
                                                            type: "button",
                                                            onClick: onClearTextInputClick,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "bi bi-trash-fill"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    id: "content-text-input",
                                                    className: "form-control",
                                                    rows: "10",
                                                    maxLength: "500000",
                                                    placeholder: "เขียนหรือวางข้อความของคุณที่นี่",
                                                    value: content,
                                                    onChange: onTextInputChange
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "p-2 pt-1 pb-3 row g-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordCountInfoPanel, {
                                                id: "word_counter",
                                                title: "จำนวนคำ",
                                                value: wordCounter.wordCount,
                                                unit: "คำ"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordCountInfoPanel, {
                                                id: "word-counter",
                                                title: "จำนวนตัวอักษร",
                                                value: wordCounter.charCount,
                                                unit: "ตัวอักษร",
                                                tooltip: "รวมช่องว่าง"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordCountInfoPanel, {
                                                id: "char-counter",
                                                title: "เวลาที่ใช้ในการอ่าน",
                                                value: wordCounter.readingTime,
                                                unit: "นาที",
                                                tooltip: "".concat(READING_SPEED_WPM, " คำ/นาที")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordCountInfoPanel, {
                                                id: "word_counter",
                                                title: "เวลาที่ใช้ในการพูด",
                                                value: wordCounter.speakingTime,
                                                unit: "นาที",
                                                tooltip: "".concat(SPEAKING_SPEED_WPM, " คำ/นาที")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-3 py-1 row g-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-sm-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h5",
                                            children: "ความหนาแน่นของคำ"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-sm-6 d-flex justify-content-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "form-check form-switch",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "form-check-input",
                                                    type: "checkbox",
                                                    id: "word-exclude-stop-words",
                                                    onChange: onExcludeStopwirdSwitchChange,
                                                    checked: wordDensityExcludeStopWords
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "form-check-label",
                                                    htmlFor: "wd-exclude-stop-words",
                                                    children: "ละเว้นคำเชื่อมประโยค"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordDensityTable, {
                                wordDensityList: wordCounter.wordDensity
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-3 pt-2 pb-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h5",
                                    children: "คำที่พบในข้อความ"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "word-list-container",
                                className: "p-2 mx-2 my-1 rounded-3 notranslate ".concat((IndexPage_module_default())["highlight-container"]),
                                children: wordCounter.words.map((word)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WordBadge, {
                                            word: word
                                        })
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "mt-1 mb-2 list-group",
                        id: "info-accordion",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "list-group-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "h5",
                                        children: "เครื่องมือนับจำนวนคำภาษาไทย CanCount"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "m-0",
                                        children: "เครื่องมือนับคำออนไลน์ CanCount เครื่องมือนับคำที่พัฒนาขึ้นมาเพื่อการนับจำนวนคำอย่างแม่นยำที่สุด ทั้งภาษาอังกฤษและภาษาไทย สามารถนับได้ทั้งจำนวนคำ จำนวนตัวอักษร คำนวณเวลาที่ใช้ในการอ่านและเวลาที่ใช้ในการพูดได้อย่างรวดเร็ว"
                                    })
                                ]
                            }, "intro"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "list-group-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "h5",
                                        children: "ทำไมคุณถึงควรใช้ CanCount"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "m-0",
                                        children: "โดยปกติแล้วหากคุณใช้งานโปรแกรม Microsoft Word คุณสามารถทราบจำนวนคำของบทความได้อยู่แล้ว แต่หากคุณไม่มีโปรแกรม Microsoft Word หรือต้องการนับคำจากอุปกรณ์มือถือ เว็บไซต์นับคำถือเป็นทางเลือกหนึ่งในการช่วยนับคำ แต่เว็บไซต์ส่วนใหญ่ไม่สามารถนับจำนวนคำภาษาไทยได้จริง CanCount จึงเป็นตัวเลือกที่เหมาะสมกับงานของท่าน"
                                    })
                                ]
                            }, "why-cancount"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "list-group-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "h5",
                                        children: "การนับจำนวนคำสำคัญอย่างไร"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "m-0",
                                        children: "การนับจำนวนคำมีส่วนช่วยในทุกๆงานเขียนของคุณ ให้งานเขียนของคุณมีปริมาณของจำนวนคำที่ถูกต้องและเหมาะสมกับงานที่คุณต้องทำ เช่น บทความเพื่อการทำ SEO นักเขียนหรือนักประพันธ์ ตลอดไปจนถึงอาจารย์ นักเรียนและนักศึกษา CanCount ก็สามารถช่วยให้การนับจำนวนคำของคุณง่ายขึ้นได้"
                                    })
                                ]
                            }, "why-word-count"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "list-group-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "h5",
                                        children: "วิเคราะห์ความหนาแน่นของคำหลัก เพิ่มประสิทธิภาพ SEO"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "m-0",
                                        children: [
                                            "นอกไปจากนี้ CanCount ยังสามารถคำนวณความหนาแน่นของคำหลักในบทความ เพื่อช่วยให้คุณสามารถประเมินและปรับเปลี่ยนปริมาณคำหลักในบทความได้อย่างเหมาะสม ส่งผลให้สามารถทำ SEO สำหรับบทความนั้นๆได้อย่างมีประสิทธิภาพมากที่สุด",
                                            " "
                                        ]
                                    })
                                ]
                            }, "feature"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "list-group-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "h5",
                                        children: "รับรองความปลอดภัยของทุกเนื้อหา"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "m-0",
                                        children: "CanCount เราให้ความสำคัญกับความเป็นส่วนตัวของคุณและเนื้อหา/บทความของคุณ ระบบของเราจะไม่บันทึกหรือจัดเก็บเนื้อหาไว้ใช้ในภายหลัง หรือนำเอาเนื้อหา/บทความดังกล่าวนี้ไปเผยแพร่ต่อสาธารณะอย่างแน่นอน"
                                    })
                                ]
                            }, "privacy"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "list-group-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "h5",
                                        children: "ใช้งานได้ฟรี ไม่มีข้อจำกัด"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "m-0",
                                        children: "คุณสามารถนับจำนวนคำ ทั้งภาษาไทยและภาษาอังกฤษได้ฟรีและไม่จำกัดจำนวนครั้ง พร้อมผลลัพธ์ที่แม่นยำ"
                                    })
                                ]
                            }, "free"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "list-group-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "h5",
                                        children: "สะดวก สบาย ใช้งานได้โดยไม่ต้องติดตั้งโปรแกรมใด ๆ"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "m-0",
                                        children: "เพราะเราเข้าใจว่าทุกเวลาของคุณมีค่า CanCount ให้คุณตรวจนับจำนวนคำและตัวอักษร ภาษาไทยและภาษาอังกฤษ ที่มีผลอย่างแม่นยำได้โดยไม่ต้องติดตั้งส่วนขยายใด ๆ เพิ่มเติม"
                                    })
                                ]
                            }, "no-installation")
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 3384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader-dimer":"IndexPage_loader-dimer__xoW8x","loader-size":"IndexPage_loader-size__QrgnG","highlight-container":"IndexPage_highlight-container___aLK5"};

/***/ }),

/***/ 6948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bullet-class":"AffiliateCarousel_bullet-class__5hi7G","bullet-class-active":"AffiliateCarousel_bullet-class-active__RsQw2"};

/***/ }),

/***/ 3414:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 172:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2001:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 3779:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 2258:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [436,577,268,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);